// Money-Summen für den "Zahlungsverkehr"-Block (Offene/Bezahlte/Summe aller Posten).
//
// openAmount-Konvention (siehe swissQR/ImportHistory/allocationState.ts):
//   null/undefined ⟺ "voller paymentAmount offen"   ·   0 ⟺ Rate ist vollständig bezahlt.
//
// Deshalb darf `openAmount ?? paymentAmount` nur für OFFENE Posten verwendet werden.
// Für BEZAHLTE Posten liefert diese Formel 0 (weil `0 ?? paymentAmount === 0`, Nullish-
// Coalescing greift nicht bei 0) — genau das ließ bei "außerhalb Mollie bezahlt"-Posten
// alle drei Kennzahlen auf 0 € fallen. Bezahlte Posten zählen daher mit `paymentAmount`.
//
// "Summe aller Posten" ist die Summe ALLER paymentAmount (= booking.grossPrice, Buchungspreis).
// Nicht offen + bezahlt: bei einer teilbezahlten offenen Rate fiele der schon bezahlte Teil heraus.

type PaymentForTotals = {
    paymentDone?: string | null;
    openAmount?: number | null;
    paymentAmount?: number | null;
};

export const calcPaymentTotals = (payments: readonly PaymentForTotals[] = []) => {
    const openAmount = payments.reduce(
        (acc, p) => (p.paymentDone == null ? acc + (p.openAmount ?? p.paymentAmount ?? 0) : acc),
        0,
    );
    const doneAmount = payments.reduce((acc, p) => (p.paymentDone != null ? acc + (p.paymentAmount ?? 0) : acc), 0);

    const sumAmount = payments.reduce((acc, p) => acc + (p.paymentAmount ?? 0), 0);

    return {openAmount, doneAmount, sumAmount};
};
